import { render, staticRenderFns } from "./RichReportComponent.vue?vue&type=template&id=0b9e17a0&scoped=true&"
import script from "./RichReportComponent.vue?vue&type=script&lang=js&"
export * from "./RichReportComponent.vue?vue&type=script&lang=js&"
import style0 from "./RichReportComponent.vue?vue&type=style&index=0&id=0b9e17a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9e17a0",
  null
  
)

export default component.exports